import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    paddingBottom: "8px",
    borderBottom: "1px solid #e0e0e0",
  },
  sectionTitle: {
    // Matches the formTitle scale used by the headings INSIDE a section, so a
    // section's own name is never smaller than a sub-heading under it.
    fontSize: "24px",
    fontWeight: 600,
    margin: 0,
  },
  editButton: {
    padding: "4px 8px",
    textTransform: "none",
    // size="small" alone left this at MUI's 13px beside a 24px title.
    fontSize: "14px",
    color: "#ec6535",
    "&:hover": {
      backgroundColor: "rgba(236, 101, 53, 0.08)",
    },
  },
}));

